export default "__VITE_ASSET__Dp_zRak4__"